import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_file_transfer_testService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: {  }): Promise<{ files?: { transaction_id?: string, name?: string, content?: string }[], messages?: any[], success?: boolean }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }

}

